// extracted by mini-css-extract-plugin
export default {"footer":"Layout_footer__1I3yD","layout":"Layout_layout__m8Vdf"};